var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',_vm._l((_vm.sticker),function(s,index){return _c('b-col',{key:index,staticClass:"mt-2 mb-2",attrs:{"cols":"4","sm":"3"}},[_c('img',{staticClass:"stk",attrs:{"src":'https://api2.novelrealm.com/resources/sticker/'+s.url,"alt":s.title,"width":"90"},on:{"click":function($event){return _vm.selectedStk(s.slug)}}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }